import { RoleRights } from "../Enums/RoleRights";

export function CheckAllRoles(rolesObject, roleToCheck) {
  for (var index in rolesObject) {
    if (rolesObject[index]["CareersRoleID"] != null) {
      if (rolesObject[index]["CareersRoleID"].toUpperCase() === roleToCheck) {
        return true;
      }
    }
  }
  return false;
}

/**
 * @description Checks to see if a user has the CRM User Management Role
 */
export function CheckCrmUserManagementRoleForClient(rolesObject, baseClientId) {
  for (var index in rolesObject) {
    if (rolesObject[index]["BaseClientID"].toUpperCase() === baseClientId) {
      if (rolesObject[index]["CRMRole"] === 2) {
        return true;
      }
      return false;
    }
  }
}

/**
 * @description Checks to see if a user has CRM Access for this Client
 */
export function CheckCrmAccessForClient(rolesObject, baseClientId) {
  for (var index in rolesObject) {
    if (rolesObject[index]["BaseClientID"].toUpperCase() === baseClientId) {
      if (
        rolesObject[index]["CRMRole"] === 1 ||
        rolesObject[index]["CRMRole"] === 2
      ) {
        return true;
      }
      return false;
    }
  }
}

export function CheckRoleForClient(rolesObject, baseClientId, roleToCheck) {
  for (var index in rolesObject) {
    if (rolesObject[index]["CareersRoleID"] != null) {
      if (rolesObject[index]["BaseClientID"].toUpperCase() === baseClientId) {
        if (rolesObject[index]["CareersRoleID"].toUpperCase() === roleToCheck) {
          return true;
        }
        return false;
      }
    }
  }
  return false;
}

export function CheckAllRights(rolesObject, rightToCheck) {
  for (var index in rolesObject) {
    if (rolesObject[index]["CareersRoleID"] != null) {
      var rightsFlag = rolesObject[index]["CareersRightsFlag"];
      if (rightsFlag & rightToCheck) {
        return true;
      }
    }
  }
  return false;
}

export function CheckRightsForClient(rolesObject, baseClientId, rightToCheck) {
  for (var index in rolesObject) {
    if (rolesObject[index]["CareersRoleID"] != null) {
      if (rolesObject[index]["BaseClientID"].toUpperCase() === baseClientId) {
        //First, check if user's role has that right (Enum: RoleRights)
        if (
          RoleRights[rightToCheck].includes(
            rolesObject[index]["CareersRoleID"].toUpperCase()
          )
        ) {
          return true;
        }
        //Else, check if user's additional rights contain right
        if (
          checkAdditionalRights(
            rightToCheck,
            rolesObject[index]["CareersRightsFlag"]
          )
        ) {
          return true;
        }

        return false;
      }
    }
  }

  return false;
}

export function CheckMultiRightsForClient(
  rolesObject,
  clientID,
  rightsToCheck
) {
  for (var index in rolesObject) {
    if (rolesObject[index]["CareersRoleID"] != null) {
      if (rolesObject[index]["BaseClientID"].toUpperCase() === clientID) {
        for (var i = 0; i < rightsToCheck.length; i++) {
          //First, check if user's role has that right (Enum: RoleRights)
          if (
            RoleRights[rightsToCheck[i]].includes(
              rolesObject[index]["CareersRoleID"].toUpperCase()
            )
          ) {
            return true;
          }
          //Else, check if user's additional rights contain right
          if (
            checkAdditionalRights(
              rightsToCheck[i],
              rolesObject[index]["CareersRightsFlag"]
            )
          ) {
            return true;
          }
        }
        return false;
      }
    }
  }
  return false;
}

function checkAdditionalRights(rightNeeded, rightsHas) {
  const rightVals = [
    65536, 32768, 16384, 8192, 4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8,
    4, 2, 1,
  ];

  for (let val in rightVals) {
    if (rightsHas - rightVals[val] >= 0) {
      if (rightVals[val] === rightNeeded) {
        return true;
      }

      rightsHas -= rightVals[val];
    }
  }

  if (rightNeeded === rightsHas) {
    return true;
  }

  return false;
}
